/* eslint-disable no-new */
import * as utilReportInventory from '@/api/reportInventory'

const actions = {
  listPerProductStoreSatuan({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listPerProductStoreSatuan(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listGudangHasTransactions({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listGudangHasTransactions(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listStokTerkini({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listStokTerkini(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listProbabilitas({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listProbabilitas(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listMutasiStok({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listMutasiStok(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPareto({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listPareto(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listMinimalStock({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listMinimalStock(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listStockHabis({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportInventory.listStockHabis(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reportInventory.js